import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Menu,
  MenuButton,
  Portal,
  MenuItem,
  MenuList,
  IconButton,
  Spinner,
  Select,
  Icon,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Input,
  Collapse,
  SimpleGrid,
  FormControl,
  FormLabel,
  Badge,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCircle,
  FaPlus,
  FaAlignJustify,
  FaBarcode,
  FaTimes,
  FaEnvelope,
  FaSms,
  FaChevronDown,
  FaCog,
  FaChevronUp,
  FaCalendarDay,
  FaDownload,
} from "react-icons/fa";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import ListaBoletoAPI, { ORDEM } from "../../../services/ListaBoleto";
import SystemApi from "../../../services/systemApi";
import ExtratoApi from "../../../services/ExtratoAPI";
import PermissionsAPI from "../../../services/permissionsAPI";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { dadosDoToken } from "../../../defaultFunctions/token";
import { componentState } from "../../../atoms/componentState";
import { LoggedUser } from "../../../atoms/userLogged";
import { customColors } from "../../../atoms/customColors";
import { permissions } from "../../../atoms/permissions";
import Pagination from "../../../defaultComponents/pagination";
import ModalDetailVendaBoleto from "./components/ModalDetailVendaBoleto";
import ModalDetailVendaBoletoLote from "./components/ModalDetailVendaBoletoLote";
import ModalConfirmCancelLote from "./components/ModalConfirmCancelLote";
import DateRangeFilter from "./components/DateRangeFilter";
import { NumericFormat } from "react-number-format";
import {
  goToAddVendaBolePix,
  goToAddVendaBolePixLote,
  goToCalender,
  goToEditBolePix,
  goToDetailsLote,
} from "../../../routes/coordinator";

const safeDate = (date?: string): string => date || "";

interface objetoSalesList {
  id: string;
  idCliente: number;
  bandeira: string;
  cpfPagador: string;
  clienteNome: string | null;
  cnpj: string;
  dataCriacao: string;
  dataExpiracao: string | null;
  dataPagamento: string | null;
  isCnpj: boolean;
  nomeFantasia: string;
  nomePagador: string;
  razaoSocial: string;
  status: string;
  taxaCliente: number;
  taxaPlano: number;
  valor: number;
  valorLiquido: number;
  barcode?: string;
  emv?: string;
  mensagem?: string;
  idLote?: string;
  numeroDocumento?: string;
  emailPagador?: string;
  telefone?: string;
  // id da transação NA ZOOP — é o número que se cita num chamado com eles
  idTransacao?: string | null;
}

interface objetoBatchList {
  idLote: string;
  idCliente: number;
  dataCriacao: string;
  status: string;
  valor: number;
  diaVencimento: number;
  parcelas: number;
  // Resumo do carnê, calculado pela core em PreencherResumoLotes (a tabela do
  // lote não guarda nada disso — quem tem é a parcela).
  qtdParcelasEmitidas: number;
  qtdParcelasPagas: number;
  proximoVencimento: string | null;
  mesesPular: number;
  descricao: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enviarSMS: boolean;
  enviarEmail: boolean;
  enviarWhats: boolean;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  isAtivo: boolean;
  RegrasJuros?: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
  RegrasMulta?: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
}

interface statusInfo {
  id: number;
  status: string;
}

interface basicInfo {
  id: number;
  nome: string;
}

interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
  loginPermissoes: string;
}

export default function SalesListBolePix() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState<objetoSalesList[]>([]);
  const [batchList, setBatchList] = useState<objetoBatchList[]>([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [openBatchDetails, setOpenBatchDetails] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [batchIdToCancel, setBatchIdToCancel] = useState("");
  // o modal precisa dos números do carnê (emitidas x total) para dizer quantos
  // boletos continuam válidos depois do cancelamento
  const [batchToCancel, setBatchToCancel] = useState<objetoBatchList | null>(null);
  const [details, setDetails] = useState<objetoSalesList | {}>({});
  const [batchDetails, setBatchDetails] = useState<objetoBatchList | {}>({});
  const [statusList, setStatusList] = useState<statusInfo[]>([]);
  const [modoPgtoList, setModoPgtoList] = useState<basicInfo[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [permissionsList, setPermissionsList] = useState<Array<any>>([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  // Padrão = criados mais recentes: quem abre a tela quase sempre procura o
  // boleto que acabou de gerar. "Por vencimento" é escolha do operador, e vale
  // para a cobrança do dia a dia ("o que vence esta semana").
  const [ordenarPor, setOrdenarPor] = useState(ORDEM.CRIACAO);

  const [colors] = useRecoilState(customColors);
  const [user] = useRecoilState(LoggedUser);
  const setPermsRecoil = useSetRecoilState(permissions);
  const token = window.localStorage.getItem("token");
  // decodificação tolerante: token ausente/corrompido não pode derrubar a tela
  const jwtToken = dadosDoToken(token) as unknown as JWTToken;
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);

  const initialValues = {
    statusFilter: 0,
    saleTypeFilter: 5,
    initialDateFilter: moment()
      .subtract(1, "month")
      .startOf("month")
      .format("YYYY-MM-DDTHH:mm:ss"),
    finalDateFilter: moment().endOf("month").format("YYYY-MM-DDTHH:mm:ss"),
    minValueFilter: 0,
    maxValueFilter: 0,
    clientFilter: "",
    issuanceDateStartFilter: "",
    issuanceDateEndFilter: "",
    dueDateStartFilter: "",
    dueDateEndFilter: "",
    // data de PAGAMENTO — junto com o vencimento, é o filtro que a operação
    // mais usa no dia a dia ("o que entrou ontem")
    paymentDateStartFilter: "",
    paymentDateEndFilter: "",
    documentFilter: "",

    IdLote: "",
    // paymentDetailsFilter: "",
    numeroDocumento: "",
    emailPagador: "",
    telefone: "",
    isAvulso: false,
  };
  const [filtros, setFiltros] = useState(initialValues);

  /**
   * Carnê completo = todas as parcelas emitidas. Usa o resumo que a core já
   * manda na listagem (qtdParcelasEmitidas), sem consulta extra.
   *
   * Lote antigo, anterior ao resumo, viria com 0 emitidas e travaria o botão à
   * toa — por isso o fallback: sem o dado, não bloqueia (a core confere).
   */
  function loteCompleto(item: objetoBatchList) {
    const total = item.parcelas ?? 0;
    if (total === 0 || item.qtdParcelasEmitidas == null) return true;
    return item.qtdParcelasEmitidas >= total;
  }

  async function handleDownloadBatch(idLote: string) {
    try {
      setLoading(true);
      await ListaBoletoAPI.downloadBatch(idLote, token || "");
      toast.success(`Download do lote ${idLote} iniciado com sucesso!`);
    } catch (error) {
      console.error("Error downloading batch:", error);
      toast.error("Erro ao iniciar o download do lote!");
    } finally {
      setLoading(false);
    }
  }

  async function handleDownloadIndividual(idBoleto: string) {
    try {
      setLoading(true);
      await ListaBoletoAPI.downloadIndividual(idBoleto, token || "");
      toast.success(`Download do boleto ${idBoleto} iniciado com sucesso!`);
    } catch (error) {
      console.error("Error downloading individual:", error);
      toast.error("Erro ao iniciar o download do boleto!");
    } finally {
      setLoading(false);
    }
  }

  async function fetchPermissions(id: string) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setPermsRecoil(response);
      setIsNotEmpty(response.length > 0);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Erro ao carregar permissões!");
    }
  }

  let loginPermissoes: number[] = [];
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        loginPermissoes = JSON.parse(decoded.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  const formatDate = (date: string | null) => {
    if (!date) return undefined;
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  };

  useEffect(() => {
    if (permissionsList.length === 0 && !isNotEmpty && jwtToken.idCliente) {
      fetchPermissions(String(jwtToken.idCliente));
    }
  }, [permissionsList, jwtToken.idCliente]);

  function temPermissao(
    userPerm: number | null,
    clientePerm: boolean,
    permArray: number[] = []
  ): boolean {
    if (!permArray.length || userPerm === null) {
      return clientePerm ?? false;
    }
    const permUser = permArray.includes(userPerm);
    const permCliente = clientePerm ?? false;
    return permUser && permCliente;
  }

  const hasBolePixPermission = temPermissao(
    44,
    permissionsList.some((perm: any) => perm.idPermissoes === 44),
    loginPermissoes
  );

  const hasBolePixPermissionLot = temPermissao(
    45,
    permissionsList.some((perm: any) => perm.idPermissoes === 45),
    loginPermissoes
  );

  async function handleCancelBatch(batchId: string) {
    try {
      setLoading(true);
      const resposta = await ListaBoletoAPI.cancelBatch(batchId);

      // a core devolve o que de fato aconteceu (quantas saíram da fila, quantas
      // continuam emitidas) — dizer só "cancelado" esconde justamente a parte
      // que o cliente precisa saber
      toast.success(resposta?.data?.mensagem || "Lote cancelado.");
      getBatchSales();
    } catch (error: any) {
      console.error("Error cancelling batch:", error);
      toast.error(
        error?.response?.data?._error ||
          error?.response?.data ||
          "Erro ao cancelar o lote!"
      );
    } finally {
      setLoading(false);
    }
  }

  async function getIndividualSales() {
    try {
      setLoading(true);
      const response = await ListaBoletoAPI.getBolepix(
        currentPage,
        pageSize,
        Number(jwtToken.idCliente),
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter,
        filtros.saleTypeFilter,
        true, // lista individual: apenas boletos avulsos (sem lote) — filtrado no servidor antes de paginar
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        undefined,
        filtros.clientFilter,
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        safeDate(formatDate(filtros.dueDateStartFilter)),
        safeDate(formatDate(filtros.dueDateEndFilter)),
        filtros.documentFilter,
        filtros.IdLote,
        // filtros.paymentDetailsFilter,
        filtros.numeroDocumento,
        filtros.emailPagador,
        filtros.telefone,
        safeDate(formatDate(filtros.paymentDateStartFilter)),
        safeDate(formatDate(filtros.paymentDateEndFilter)),
        ordenarPor
      );

      const mappedSales: objetoSalesList[] = response.data
        .filter((item: any) => !item.idLote)
        .map((item: any) => ({
          id: item.id,
          idCliente: item.idCliente,
          bandeira: item.transacao?.bandeira || "N/A",
          clienteNome: item.transacao?.clienteNome || "N/A",
          cpfPagador: item.cpfPagador || "N/A",
          // Dados do beneficiário (EC) vêm planos da vw_Bolepix (EC_*)
          cnpj: item.eC_Cnpj || item.EC_Cnpj || "N/A",
          dataCriacao: item.transacao?.dataCriacao || item.criadoEm || "",
          dataExpiracao:
            item.transacao?.dataExpiracao || item.dataVencimento || null,
          dataPagamento: item.transacao?.dataPagamento || null,
          isCnpj: item.eC_IsCnpj ?? item.EC_IsCnpj ?? false,
          nomeFantasia: item.eC_NomeFantasia || item.EC_NomeFantasia || "N/A",
          razaoSocial: item.eC_RazaoSocial || item.EC_RazaoSocial || "N/A",
          nomePagador: item.nomePagador || "N/A",
          status: item.status || "unknown",
          taxaCliente: item.transacao?.taxaCliente || 0,
          taxaPlano: item.transacao?.taxaPlano || 0,
          valor:
            item.transacao?.valor ||
            parseFloat(item.valor?.replace(",", ".")) ||
            0,
          valorLiquido: item.transacao?.valorLiquido || 0,
          barcode: item.barcode || "N/A",
          emv: item.emv || "N/A",
          mensagem: item.mensagem || "N/A",
          numeroDocumento: item.numeroDocumento || "N/A",
          emailPagador: item.emailPagador || "N/A",
          telefone: item.numeroPagador || "N/A",
          idTransacao: item.idTransacao || null,
        }));

      // console.log("mappedSales", mappedSales);
      setSalesList(mappedSales);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
    } catch (error) {
      console.error("Error fetching individual sales:", error);
      toast.error("Erro ao carregar vendas individuais!");
    } finally {
      setLoading(false);
    }
  }

  async function getBatchSales() {
    try {
      setLoading(true);
      const response = await ListaBoletoAPI.getBolepixLote(
        currentPage,
        pageSize,
        Number(jwtToken.idCliente),
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter,
        filtros.saleTypeFilter,
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        filtros.clientFilter,
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        safeDate(formatDate(filtros.dueDateStartFilter)),
        safeDate(formatDate(filtros.dueDateEndFilter)),
        filtros.documentFilter,
        filtros.IdLote,
        // filtros.paymentDetailsFilter,
        filtros.numeroDocumento,
        filtros.emailPagador,
        filtros.telefone,
        safeDate(formatDate(filtros.paymentDateStartFilter)),
        safeDate(formatDate(filtros.paymentDateEndFilter)),
        ordenarPor
      );

      const mappedBatches: objetoBatchList[] = response.data.map(
        (item: any) => ({
          idLote: item.id,
          idCliente: item.idCliente,
          dataCriacao: item.criadoEm || "",
          status: item.status || "unknown",
          valor: item.valorTotal || 0,
          diaVencimento: item.diaVencimento || 1,
          parcelas: item.parcelas || 0,
          qtdParcelasEmitidas: item.qtdParcelasEmitidas ?? 0,
          qtdParcelasPagas: item.qtdParcelasPagas ?? 0,
          proximoVencimento: item.proximoVencimento ?? null,
          mesesPular: item.mesesPular || 0,
          descricao: item.mensagem || "N/A",
          cpfPagador: item.destinatarioCPF || "N/A",
          nomePagador: item.destinatarioNome || "N/A",
          emailPagador: item.destinatarioEmail || "N/A",
          enderRua: item.destinatarioRua || "N/A",
          enderBairro: item.enderBairro || "N/A",
          enderCEP: item.enderCEP || "N/A",
          enderCidade: item.enderCidade || "N/A",
          enderComplemento: item.enderComplemento || "N/A",
          enviarEmail: item.enviarEmail ?? false,
          enviarSMS: item.enviarSMS ?? false,
          enviarWhats: item.enviarWhats ?? false,
          enderEstado: item.enderEstado || "N/A",
          enderNumero: item.destinatarioN || "N/A",
          enderReferencia: item.destinatarioReferencia || "N/A",
          permitirRegras: item.permitirRegras || false,
          isAtivo: item.isAtivo ?? false,
          RegrasJuros: {
            mode: item.RegrasJuros?.mode || "SEM_JUROS",
            amount: item.RegrasJuros?.amount || 0,
            percentage: item.RegrasJuros?.percentage || 0,
            start_date: item.RegrasJuros?.start_date || "",
          },
          RegrasMulta: {
            mode: item.RegrasMulta?.mode || "SEM_MULTA",
            amount: item.RegrasMulta?.amount || 0,
            percentage: item.RegrasMulta?.percentage || 0,
            start_date: item.RegrasMulta?.start_date || "",
          },
        })
      );

      setBatchList(mappedBatches);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
    } catch (error) {
      console.error("Error fetching batch sales:", error);
      toast.error("Erro ao carregar lotes!");
    } finally {
      setLoading(false);
    }
  }

  async function exportReport() {
    try {
      setLoading(true);

      const isLote = tabIndex === 1;

      const response = await ListaBoletoAPI.exportBolepix(
        Number(jwtToken.idCliente),
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter,
        filtros.saleTypeFilter,
        filtros.isAvulso,
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        undefined,
        filtros.clientFilter,
        safeDate(formatDate(filtros.issuanceDateStartFilter)),
        safeDate(formatDate(filtros.issuanceDateEndFilter)),
        safeDate(formatDate(filtros.dueDateStartFilter)),
        safeDate(formatDate(filtros.dueDateEndFilter)),
        filtros.documentFilter,
        filtros.IdLote,
        filtros.numeroDocumento,
        filtros.emailPagador,
        filtros.telefone,
        isLote,
        safeDate(formatDate(filtros.paymentDateStartFilter)),
        safeDate(formatDate(filtros.paymentDateEndFilter))
      );

      const fileName = isLote
        ? `relatorio_lotes_${moment().format("YYYYMMDD_HHmm")}.xlsx`
        : `relatorio_boletos_${moment().format("YYYYMMDD_HHmm")}.xlsx`;

      fileDownload(response.data, fileName);
      toast.success("Relatório exportado com sucesso!");
    } catch (error) {
      toast.error("Erro ao exportar o relatório. Tente novamente.");
      console.error("Export error:", error);
    } finally {
      setLoading(false);
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      const filteredResponse = response.filter(
        (item: any) =>
          item.idStatus === 1 || item.idStatus === 2 || item.idStatus === 3
      );

      setStatusList(response);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  }

  async function getModoPgtoList() {
    try {
      const response = await SystemApi.getTransacoesModoPagamento();
      setModoPgtoList(response);
    } catch (error) {
      console.error("Error fetching payment methods:", error);
    }
  }

  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
    getStatusList();
    getModoPgtoList();
  }, []);

  useEffect(() => {
    if (tabIndex === 0) {
      getIndividualSales();
    } else {
      getBatchSales();
    }
  }, [
    tabIndex,
    // search,
    currentPage,
    pageSize,
    ordenarPor,
    // filtros.statusFilter,
    // filtros.saleTypeFilter,
    // filtros.issuanceDateStartFilter,
    // filtros.issuanceDateEndFilter,
    // filtros.dueDateStartFilter,
    // filtros.dueDateEndFilter,
    // filtros.minValueFilter,
    // filtros.maxValueFilter,
    // filtros.clientFilter,
    // filtros.documentFilter,
    // filtros.IdLote,
    // filtros.paymentDetailsFilter,
    // filtros.numeroDocumento,
    // filtros.emailPagador,
    // filtros.telefone,
    // filtros.isAvulso,
  ]);
  const statusOptions = statusList.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.status,
  }));

  const modoPgtoOptions = modoPgtoList.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.nome,
  }));

  const handleFilterChange = (field: keyof typeof filtros, value: any) => {
    setFiltros((prev) => ({ ...prev, [field]: value }));
    setCurrentPage(1);
  };

  const onChangeStatusFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleFilterChange("statusFilter", Number(e.target.value));
  };

  const onChangeModoPgtoFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleFilterChange("saleTypeFilter", Number(e.target.value));
  };

  const onChangeSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  const formatCpfCnpj = (value?: string) => {
    if (!value) return "-";
    const digits = value.replace(/\D/g, "");
    if (digits.length === 11)
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    if (digits.length === 14)
      return digits.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    return value;
  };

  const getStatusColor = (status: string, isAtivo?: boolean) => {
    if (isAtivo !== undefined) {
      return isAtivo ? colors.GREENMONEDD : colors.REDMONEDD;
    }
    switch (status) {
      case "succeeded":
        return colors.GREENMONEDD;
      case "pending":
        return colors.YELLOWMONEDD;
      case "failed":
        return colors.ORANGEMONEDD;
      case "new":
        return colors.GRAYCARD;
      case "chargeback":
        return colors.REDCARD;
      case "canceled":
        return colors.REDMONEDD;
      default:
        return colors.GRAY;
    }
  };

  const translateStatus = (status: string) => {
    switch (status) {
      case "succeeded":
        return "Sucesso";
      case "pending":
        return "Pendente";
      case "failed":
        return "Falhou";
      case "new":
        return "Novo";
      case "chargeback":
        return "Chargeback";
      case "canceled":
        return "Cancelado";
      case "unknown":
        return "Criado";
      default:
        return status;
    }
  };

  const renderTable = (isBatch: boolean = false) => (
    /* Ocupa a altura que sobrar no card em vez de um 48vh fixo, que deixava
       metade da tela vazia e a área de rolagem minúscula. O minH={0} é o que
       permite um filho flex encolher e criar o próprio scroll. */
    <TableContainer
      maxWidth="100%"
      overflowX="auto"
      overflowY="auto"
      flex="1"
      minH={0}
    >
      <Table
        variant="simple"
        size="md"
        colorScheme="gray"
        width="100%"
        minWidth={isBatch ? "1100px" : "1400px"}
      >
        <Thead>
          <Tr>
            {!isBatch && (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                borderTopLeftRadius="md"
                minWidth="120px"
                whiteSpace="nowrap"
              >
                Número Documento
              </Th>
            )}
            {isBatch ? (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                borderTopLeftRadius="md"
                minWidth="120px"
                whiteSpace="nowrap"
              >
                Data
              </Th>
            ) : (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                minWidth="120px"
                whiteSpace="nowrap"
              >
                Data
              </Th>
            )}

            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              Pagador
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              CPF/CNPJ
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Status
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Vencimento
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Total
            </Th>
            {isBatch && (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                minWidth="80px"
                whiteSpace="nowrap"
              >
                Parcelas
              </Th>
            )}
            {isBatch && (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                minWidth="120px"
                whiteSpace="nowrap"
              >
                Notificações
              </Th>
            )}
            {!isBatch && (
              <Th
                bgColor={colors.BLUEMONEDDBACKGROUND}
                color={colors.WHITE}
                minWidth="180px"
                whiteSpace="nowrap"
                title="Identificador da transação — é o número a informar no suporte"
              >
                ID Transação
              </Th>
            )}
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopRightRadius="md"
              minWidth="80px"
              whiteSpace="nowrap"
              position="sticky"
              right={0}
              zIndex={1}
              bg={colors.BLUEMONEDDBACKGROUND}
            >
              Opções
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {isBatch ? (
            batchList.length === 0 ? (
              <Tr>
                <Td colSpan={9} textAlign="center">
                  Nenhum lote encontrado
                </Td>
              </Tr>
            ) : (
              batchList.map((item, index) => (
                <Tr
                  key={index}
                  _hover={{ bg: colors.GRAY_LIGHTEST }}
                  transition="background 0.2s"
                >
                  <Td whiteSpace="nowrap">
                    {item.dataCriacao
                      ? moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </Td>
                  <Td whiteSpace="nowrap">{item.nomePagador || "-"}</Td>
                  <Td whiteSpace="nowrap">{formatCpfCnpj(item.cpfPagador)}</Td>
                  <Td whiteSpace="nowrap">
                    <Flex alignItems="center">
                      <Icon
                        as={FaCircle}
                        color={getStatusColor(item.status, item.isAtivo)}
                        boxSize={3}
                        mr={2}
                      />
                      {item.isAtivo ? "Ativo" : "Cancelado"}
                    </Flex>
                  </Td>
                  {/* O lote não tem vencimento — tem um carnê de parcelas. O que
                      importa para cobrar é a PRÓXIMA em aberto; o "Dia N" fica
                      abaixo, como a regra que gerou o carnê. */}
                  <Td whiteSpace="nowrap">
                    <VencimentoBadge data={item.proximoVencimento} />
                    <Text fontSize="10px" color={colors.GRAY}>
                      {item.diaVencimento ? `todo dia ${item.diaVencimento}` : ""}
                    </Text>
                  </Td>
                  <Td whiteSpace="nowrap">
                    {(item.valor ?? 0).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Td>
                  <Td whiteSpace="nowrap">
                    <Text fontSize="sm">
                      {item.qtdParcelasEmitidas ?? 0}/{item.parcelas ?? 0} emitidas
                    </Text>
                    <Badge
                      colorScheme={
                        (item.qtdParcelasPagas ?? 0) >= (item.parcelas ?? 0)
                          ? "green"
                          : "gray"
                      }
                      fontSize="10px"
                    >
                      {item.qtdParcelasPagas ?? 0} paga(s)
                    </Badge>
                  </Td>
                  <Td whiteSpace="nowrap">
                    <Flex gap={2}>
                      <Icon
                        as={FaEnvelope}
                        color={
                          item.enviarEmail
                            ? colors.BLUEMONEDDBUTTONS
                            : colors.GRAY
                        }
                        boxSize={5}
                        title={
                          item.enviarEmail
                            ? "E-mail ativado"
                            : "E-mail desativado"
                        }
                      />
                      <Icon
                        as={FaSms}
                        color={
                          item.enviarSMS
                            ? colors.BLUEMONEDDBUTTONS
                            : colors.GRAY
                        }
                        boxSize={5}
                        title={
                          item.enviarSMS ? "SMS ativado" : "SMS desativado"
                        }
                      />
                    </Flex>
                  </Td>
                  <Td
                    whiteSpace="nowrap"
                    position="sticky"
                    right={0}
                    zIndex={1}
                    bg={colors.WHITE}
                  >
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label="Options"
                        icon={<HamburgerIcon />}
                        bgColor={colors.BLUEMONEDDBUTTONS}
                        color={colors.WHITE}
                        size="sm"
                        _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
                        _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
                        transition="all 0.2s"
                      />
                      <Portal>
                        <MenuList>
                        <MenuItem
                          onClick={() => {
                            setOpenBatchDetails(true);
                            setBatchDetails(item);
                          }}
                          _hover={{ bg: colors.GRAY_LIGHT }}
                        >
                          <Flex alignItems="center">
                            Visualizar Detalhes
                            <Icon
                              as={FaAlignJustify}
                              color={colors.BLUEMONEDDBUTTONS}
                              boxSize={4}
                              ml={2}
                            />
                          </Flex>
                        </MenuItem>
                        <MenuItem
                          onClick={() => goToDetailsLote(navigate, item.idLote)}
                          _hover={{ bg: colors.GRAY_LIGHT }}
                        >
                          <Flex alignItems="center">
                            Visualizar Boletos
                            <Icon
                              as={FaBarcode}
                              color={colors.BLUEMONEDDBUTTONS}
                              boxSize={4}
                              ml={2}
                            />
                          </Flex>
                        </MenuItem>
                        {/* O PDF do lote é montado sobre o que ESTÁ emitido:
                            baixado no meio da geração sai um carnê pela metade,
                            com cara de completo. Liberado só quando todas as
                            parcelas saíram — a core recusa de qualquer forma. */}
                        <MenuItem
                          isDisabled={!loteCompleto(item)}
                          title={
                            loteCompleto(item)
                              ? "Baixar o carnê completo em PDF"
                              : `Ainda faltam ${(item.parcelas ?? 0) - (item.qtdParcelasEmitidas ?? 0)} de ${item.parcelas ?? 0} parcela(s) para emitir`
                          }
                          onClick={() => {
                            if (!loteCompleto(item)) return;
                            handleDownloadBatch(item.idLote);
                          }}
                          _hover={{ bg: colors.GRAY_LIGHT }}
                        >
                          <Flex alignItems="center">
                            Download Lote
                            <Icon
                              as={FaDownload}
                              color={colors.BLUEMONEDDBUTTONS}
                              boxSize={4}
                              ml={2}
                            />
                          </Flex>
                        </MenuItem>
                        {item.isAtivo && (
                          <MenuItem
                            onClick={() => {
                              setBatchIdToCancel(item.idLote);
                              setBatchToCancel(item);
                              setOpenCancelModal(true);
                            }}
                            _hover={{ bg: colors.GRAY_LIGHT }}
                          >
                            <Flex alignItems="center">
                              Cancelar Lote
                              <Icon
                                as={FaTimes}
                                color={colors.REDMONEDD}
                                boxSize={4}
                                ml={2}
                              />
                            </Flex>
                          </MenuItem>
                        )}
                        </MenuList>
                      </Portal>
                    </Menu>
                  </Td>
                </Tr>
              ))
            )
          ) : salesList.length === 0 ? (
            <Tr>
              <Td colSpan={9} textAlign="center">
                Nenhuma venda encontrada
              </Td>
            </Tr>
          ) : (
            salesList.map((item, index) => (
              <Tr
                key={index}
                _hover={{ bg: colors.GRAY_LIGHTEST }}
                transition="background 0.2s"
              >
                <Td whiteSpace="nowrap">{item.numeroDocumento || "-"}</Td>
                <Td whiteSpace="nowrap">
                  {item.dataCriacao
                    ? moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">{item.nomePagador || "-"}</Td>
                <Td whiteSpace="nowrap">{formatCpfCnpj(item.cpfPagador)}</Td>
                <Td whiteSpace="nowrap">
                  <Flex alignItems="center">
                    <Icon
                      as={FaCircle}
                      color={getStatusColor(item.status)}
                      boxSize={3}
                      mr={2}
                    />

                    {translateStatus(item.status)}
                  </Flex>
                </Td>
                <Td whiteSpace="nowrap">
                  {/* "Pago" sai do STATUS, não da dataPagamento: ela vem
                      preenchida com o vencimento em transações `pending`, e o
                      badge dava o boleto como quitado sem ninguém ter pago. */}
                  <VencimentoBadge
                    data={item.dataExpiracao}
                    pago={["paid", "succeeded"].includes(
                      (item.status || "").toLowerCase()
                    )}
                  />
                </Td>
                <Td whiteSpace="nowrap">
                  {(item.valor ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td>
                <Td whiteSpace="nowrap">
                  <IdTransacao valor={item.idTransacao} />
                </Td>
                <Td
                  whiteSpace="nowrap"
                  position="static"
                  right={0}
                  zIndex={0}
                  bg={colors.WHITE}
                >
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<HamburgerIcon />}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                      size="sm"
                      _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
                      _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
                      transition="all 0.2s"
                    />
                    <Portal>
                      <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenDetails(true);
                          setDetails(item);
                        }}
                        _hover={{ bg: colors.GRAY_LIGHT }}
                      >
                        <Flex alignItems="center">
                          Visualizar Detalhes
                          <Icon
                            as={FaAlignJustify}
                            color={colors.BLUEMONEDDBUTTONS}
                            boxSize={4}
                            ml={2}
                          />
                        </Flex>
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => handleDownloadIndividual(item.id)}
                        _hover={{ bg: colors.GRAY_LIGHT }}
                      >
                        <Flex alignItems="center">
                          Download do Boleto
                          <Icon
                            as={FaDownload}
                            color={colors.BLUEMONEDDBUTTONS}
                            boxSize={4}
                            ml={2}
                          />
                        </Flex>
                      </MenuItem> */}
                      </MenuList>
                    </Portal>
                  </Menu>
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );

  return (
    /* Altura da viewport com rolagem de segurança: em telas 4:3 (1024x768) o
       cabeçalho + filtros abertos não cabem nos 90vh, e o `overflow: hidden`
       original simplesmente cortava a tabela. */
    <Flex
      flexDir="column"
      height="90vh"
      width="100%"
      bgColor={colors.GRAY_LIGHTEST}
      p={{ base: 3, md: 5, xl: 8 }}
      overflowX="hidden"
      overflowY="auto"
    >
      <Box
        bg={colors.WHITE}
        borderRadius="lg"
        boxShadow="sm"
        p={{ base: 4, md: 6 }}
        mb={{ base: 4, md: 6 }}
        border="1px solid"
        borderColor={colors.GRAY_LIGHTER}
      >
        <Flex justify="space-between" align="center" wrap="wrap" gap={3} mb={4}>
          <Flex alignItems="center" minW={0}>
            <Icon
              as={FaPlus}
              color={colors.BLUEMONEDDBUTTONS}
              boxSize={6}
              mr={3}
            />
            <Text
              fontSize={{ base: "lg", md: "xl", "2xl": "2xl" }}
              fontWeight="semibold"
              color={colors.BLUEMONEDDBACKGROUND}
            >
              Venda Gestão de Boletos
            </Text>
          </Flex>
          <Flex
            align="center"
            gap={2}
            wrap="wrap"
            justify={{ base: "flex-start", md: "flex-end" }}
          >
            {/* Ordenação é do SERVIDOR (a paginação também é): trocar aqui
                refaz a busca da primeira página, senão a ordem valeria só
                dentro dos 15 registros já carregados. */}
            <Select
              size="sm"
              w={{ base: "100%", sm: "260px" }}
              maxW="100%"
              value={ordenarPor}
              title={
                tabIndex === 1
                  ? "Por vencimento = o carnê com a próxima parcela em aberto mais próxima"
                  : "Por vencimento = quem vence antes no topo"
              }
              onChange={(e) => {
                setCurrentPage(1);
                setOrdenarPor(e.target.value);
              }}
            >
              <option value={ORDEM.CRIACAO}>Ordenar: criados mais recentes</option>
              <option value={ORDEM.VENCIMENTO}>Ordenar: por vencimento</option>
            </Select>
            <Button
              size="sm"
              variant="outline"
              colorScheme="blue"
              onClick={() => {
                setFiltros(initialValues);
                console.log("filtros", filtros);
                setCurrentPage(1);
              }}
              _hover={{ bg: colors.GRAY_LIGHT }}
            >
              Limpar Filtros
            </Button>
            <Button
              size="sm"
              variant="outline"
              colorScheme="blue"
              onClick={() => {
                if (tabIndex === 0) {
                  getIndividualSales();
                } else {
                  getBatchSales();
                }
                setCurrentPage(1);
              }}
              _hover={{ bg: colors.GRAY_LIGHT }}
            >
              Pesquisar
            </Button>
            <IconButton
              aria-label={showFilters ? "Esconder filtros" : "Mostrar filtros"}
              icon={showFilters ? <FaChevronUp /> : <FaChevronDown />}
              size="sm"
              variant="ghost"
              colorScheme="blue"
              onClick={() => setShowFilters(!showFilters)}
            />
          </Flex>
        </Flex>
        <Collapse in={showFilters} animateOpacity>
          <SimpleGrid
            columns={{ base: 1, sm: 2, lg: 3, xl: 4, "2xl": 5 }}
            spacing={4}
            mt={4}
          >
            {/* Filtro "Status do Pagador" removido a pedido do cliente */}
            {/* <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Tipo de Venda
              </FormLabel>
              <Select
                size="sm"
                value={filtros.saleTypeFilter}
                onChange={onChangeModoPgtoFilter}
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              >
                {modoPgtoOptions.map((item) => (
                  <option value={item.value} key={item.key}>
                    {item.text}
                  </option>
                ))}
              </Select>
            </FormControl> */}
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Valor (Mín / Máx)
              </FormLabel>
              <Flex gap={2}>
                <NumericFormat
                  customInput={Input}
                  size="sm"
                  prefix="R$ "
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  value={filtros.minValueFilter || ""}
                  onValueChange={(v) =>
                    handleFilterChange("minValueFilter", v.floatValue ?? 0)
                  }
                  placeholder="Mínimo"
                  bg={colors.GRAY_LIGHTEST}
                  borderColor={colors.GRAY_LIGHTER}
                  _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                  _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
                />
                <NumericFormat
                  customInput={Input}
                  size="sm"
                  prefix="R$ "
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  value={filtros.maxValueFilter || ""}
                  onValueChange={(v) =>
                    handleFilterChange("maxValueFilter", v.floatValue ?? 0)
                  }
                  placeholder="Máximo"
                  bg={colors.GRAY_LIGHTEST}
                  borderColor={colors.GRAY_LIGHTER}
                  _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                  _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
                />
              </Flex>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Nome do Pagador
              </FormLabel>
              <Input
                size="sm"
                value={filtros.clientFilter}
                onChange={(e) =>
                  handleFilterChange("clientFilter", e.target.value)
                }
                placeholder="Nome do pagador"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Data de Emissão
              </FormLabel>
              <DateRangeFilter
                start={filtros.issuanceDateStartFilter}
                end={filtros.issuanceDateEndFilter}
                accentColor={colors.BLUEMONEDDBUTTONS}
                onChange={(s, e) =>
                  setFiltros((prev) => ({
                    ...prev,
                    issuanceDateStartFilter: s,
                    issuanceDateEndFilter: e,
                  }))
                }
              />
            </FormControl>

            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Data de Vencimento
              </FormLabel>
              <DateRangeFilter
                start={filtros.dueDateStartFilter}
                end={filtros.dueDateEndFilter}
                accentColor={colors.BLUEMONEDDBUTTONS}
                onChange={(s, e) =>
                  setFiltros((prev) => ({
                    ...prev,
                    dueDateStartFilter: s,
                    dueDateEndFilter: e,
                  }))
                }
              />
            </FormControl>

            {/* O filtro por "data de pagamento" saiu daqui porque ele MENTIA.
                Medido na base em 28/08/2026: dos bolepix com transação
                succeeded, TODOS estão com `Transacao.dataPagamento` NULL, e os
                que a têm preenchida são pending/canceled (é o vencimento
                copiado). Ou seja, filtrar por ela devolvia exatamente o
                conjunto errado — os não pagos.

                Quem foi pago de verdade se sabe pela linha de crédito no
                extrato (tipo 26), que é a régua do Painel de Gestão. */}
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Boletos pagos
              </FormLabel>
              <Button
                size="sm"
                w="100%"
                variant="outline"
                colorScheme="blue"
                onClick={() =>
                  navigate("/vendas/bolepix/gestao?situacao=pagos")
                }
              >
                Ver recebidos por período
              </Button>
              <Text fontSize="xs" color="gray.500" mt={1}>
                pela data em que o dinheiro caiu na conta
              </Text>
            </FormControl>

            {/*   <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Avulso
              </FormLabel>
              <Select
                size="sm"
                value={filtros.isAvulso ? "true" : "false"}
                onChange={(e) =>
                  handleFilterChange("isAvulso", e.target.value === "true")
                }
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
              >
                <option value="false">Todos</option>
                <option value="true">Apenas Avulso</option>
                <option value="false">Apenas Lote</option>
              </Select>
            </FormControl> */}
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                CPF/CNPJ Pagador
              </FormLabel>
              <Input
                size="sm"
                value={filtros.documentFilter}
                onChange={(e) =>
                  handleFilterChange("documentFilter", e.target.value)
                }
                placeholder="999.999.999-99 ou 99.999.999/9999-99"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Lote
              </FormLabel>
              <Input
                size="sm"
                value={filtros.IdLote}
                onChange={(e) => handleFilterChange("IdLote", e.target.value)}
                placeholder="ID do lote"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Email
              </FormLabel>
              <Input
                size="sm"
                value={filtros.emailPagador}
                onChange={(e) =>
                  handleFilterChange("emailPagador", e.target.value)
                }
                placeholder="exemplo@dominio.com"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Telefone
              </FormLabel>
              <Input
                size="sm"
                value={filtros.telefone}
                onChange={(e) => handleFilterChange("telefone", e.target.value)}
                placeholder="(99) 99999-9999"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="sm" fontWeight="medium" color="gray.600">
                Número Documento
              </FormLabel>
              <Input
                size="sm"
                value={filtros.numeroDocumento}
                onChange={(e) =>
                  handleFilterChange("numeroDocumento", e.target.value)
                }
                placeholder="Número do documento"
                bg={colors.GRAY_LIGHTEST}
                borderColor={colors.GRAY_LIGHTER}
                _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
                _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
              />
            </FormControl>
          </SimpleGrid>
        </Collapse>
      </Box>
      {/* minH garante área de tabela utilizável quando a viewport é baixa
          (4:3 ou ultrawide 1080p); flex="1" continua esticando quando sobra. */}
      <Box
        flex="1"
        minH={{ base: "360px", md: "420px" }}
        display="flex"
        flexDirection="column"
        bg={colors.WHITE}
        borderRadius="lg"
        boxShadow="md"
        p={{ base: 4, md: 6 }}
        overflow="visible"
      >
        <Flex wrap="wrap" gap={4} mb={6}>
          {hasBolePixPermission && (
            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              size="md"
              onClick={() => goToAddVendaBolePix(navigate)}
              leftIcon={<FaPlus />}
              _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
              _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
              transition="all 0.2s"
            >
              Novo Boleto Individual
            </Button>
          )}
          {hasBolePixPermissionLot && (
            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              size="md"
              onClick={() => goToAddVendaBolePixLote(navigate)}
              leftIcon={<FaPlus />}
              _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
              _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
              transition="all 0.2s"
            >
              Novos Boletos em Lote
            </Button>
          )}
          {/* Entrada para o painel de gestao: a vencer / vencidos / recebidos,
              com contadores somados no servidor e exportacao. */}
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            size="md"
            onClick={() => navigate("/vendas/bolepix/gestao")}
            leftIcon={<FaAlignJustify />}
            _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
            _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
            transition="all 0.2s"
          >
            Painel de Gestão
          </Button>
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            size="md"
            onClick={() => goToEditBolePix(navigate, jwtToken.idCliente)}
            leftIcon={<FaCog />}
            _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
            _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
            transition="all 0.2s"
          >
            Configure seu estilo de boleto!
          </Button>
          <Button
            bgColor="transparent"
            color={colors.BLUEMONEDDBUTTONS}
            size="md"
            onClick={exportReport}
            isLoading={loading}
            leftIcon={<FaPlus />}
            _hover={{ color: colors.BLUEMONEDDRGB2 }}
            transition="all 0.2s"
          >
            Exportar Relatório
          </Button>
          <Button
            bgColor="transparent"
            color={colors.BLUEMONEDDBUTTONS}
            size="md"
            onClick={() => goToCalender(navigate)}
            isLoading={loading}
            leftIcon={<FaCalendarDay />}
            _hover={{ color: colors.BLUEMONEDDRGB2 }}
            transition="all 0.2s"
          >
            Calendário
          </Button>
        </Flex>
        <Tabs
          variant="unstyled"
          flex="1"
          minH={0}
          display="flex"
          flexDirection="column"
          index={tabIndex}
          onChange={(index) => {
            setTabIndex(index);
            setCurrentPage(1);
          }}
        >
          <TabList
            mb={4}
            borderBottom="2px solid"
            borderColor={colors.GRAY_LIGHTER}
          >
            <Tab
              px={6}
              py={3}
              fontWeight="semibold"
              color={
                tabIndex === 0 ? colors.BLUEMONEDDBUTTONS : colors.GRAY_DARK
              }
              borderBottom={
                tabIndex === 0
                  ? `3px solid ${colors.BLUEMONEDDBUTTONS}`
                  : "none"
              }
              _hover={{ color: colors.BLUEMONEDDBUTTONS }}
              _focus={{ outline: "none" }}
            >
              Individual
            </Tab>
            {hasBolePixPermissionLot && (
              <Tab
                px={6}
                py={3}
                fontWeight="semibold"
                color={
                  tabIndex === 1 ? colors.BLUEMONEDDBUTTONS : colors.GRAY_DARK
                }
                borderBottom={
                  tabIndex === 1
                    ? `3px solid ${colors.BLUEMONEDDBUTTONS}`
                    : "none"
                }
                _hover={{ color: colors.BLUEMONEDDRGB2 }}
                _focus={{ outline: "none" }}
              >
                Lote
              </Tab>
            )}
          </TabList>
          <TabPanels flex="1" minH={0} display="flex">
            <TabPanel p={0} w="100%" display="flex" flexDirection="column">
              {loading ? (
                <Flex
                  flex="1"
                  minH="240px"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Spinner
                    size="xl"
                    color={colors.BLUEMONEDDBUTTONS}
                    thickness="4px"
                  />
                </Flex>
              ) : (
                renderTable(false)
              )}
            </TabPanel>
            <TabPanel p={0} w="100%" display="flex" flexDirection="column">
              {loading ? (
                <Flex
                  flex="1"
                  minH="240px"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Spinner
                    size="xl"
                    color={colors.BLUEMONEDDBUTTONS}
                    thickness="4px"
                  />
                </Flex>
              ) : (
                renderTable(true)
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
        <Flex
          justifyContent="center"
          alignItems="center"
          wrap="wrap"
          mt={{ base: 4, md: 6 }}
          gap={4}
        >
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            width="80px"
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
        <ModalDetailVendaBoleto
          isOpen={openDetails}
          setIsOpen={setOpenDetails}
          item={details}
        />
        <ModalDetailVendaBoletoLote
          isOpen={openBatchDetails}
          setIsOpen={setOpenBatchDetails}
          item={batchDetails}
        />
        <ModalConfirmCancelLote
          isOpen={openCancelModal}
          setIsOpen={setOpenCancelModal}
          onConfirm={() => handleCancelBatch(batchIdToCancel)}
          batchId={batchIdToCancel}
          emitidas={batchToCancel?.qtdParcelasEmitidas}
          total={batchToCancel?.parcelas}
        />
      </Box>
    </Flex>
  );
}

/**
 * Data de vencimento com a URGÊNCIA à vista: só "20/08/2026" obriga quem cobra a
 * fazer a conta de cabeça em cada linha. Vencido sai em vermelho, e o que vence
 * dentro de 7 dias em laranja.
 *
 * Boleto já pago não recebe selo: "venceu há 30d" num título quitado é ruído —
 * a data continua ali para conferência.
 */
function VencimentoBadge({
  data,
  pago,
}: {
  data?: string | null;
  pago?: boolean;
}) {
  if (!data) return <Text fontSize="xs">-</Text>;

  const vencimento = moment(data);
  if (!vencimento.isValid()) return <Text fontSize="xs">-</Text>;

  const dias = vencimento.startOf("day").diff(moment().startOf("day"), "days");
  const vencido = dias < 0 && !pago;

  return (
    <Flex direction="column" gap="2px">
      <Text fontSize="sm" fontWeight={vencido ? "bold" : "normal"} color={vencido ? "red.600" : "inherit"}>
        {vencimento.format("DD/MM/YYYY")}
      </Text>
      {!pago && (
        <Badge
          colorScheme={vencido ? "red" : dias <= 7 ? "orange" : "gray"}
          fontSize="10px"
        >
          {vencido
            ? `venceu há ${Math.abs(dias)}d`
            : dias === 0
            ? "vence hoje"
            : `em ${dias}d`}
        </Badge>
      )}
    </Flex>
  );
}

/**
 * ID da transação, INTEIRO e com clique para copiar.
 *
 * É o id na Zoop, mas o NOME DO PROVEDOR não aparece para o cliente: quem usa o
 * portal contrata a Monedd, e citar o parceiro na tela só levanta pergunta que
 * não é dele. Truncar não serve — o id só tem uso colado num chamado, e um
 * pedaço dele não abre nada. Boleto sem emissão não tem transação: sai um traço,
 * que é a informação certa (não existe id ainda).
 */
function IdTransacao({ valor }: { valor?: string | null }) {
  if (!valor)
    return (
      <Text fontSize="xs" color="gray.400">
        -
      </Text>
    );

  return (
    <Text
      fontSize="10px"
      fontFamily="monospace"
      whiteSpace="nowrap"
      cursor="pointer"
      title="Clique para copiar"
      _hover={{ textDecoration: "underline" }}
      onClick={() => {
        navigator.clipboard?.writeText(valor);
        toast.info("ID da transação copiado.");
      }}
    >
      {valor}
    </Text>
  );
}
